import { Search } from "@mui/icons-material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupIcon from '@mui/icons-material/Group';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Alert, AlertColor, Box, Divider, IconButton, Menu, MenuItem, Snackbar, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import LoaderComp from "../../../../../components/Loader/LoaderComp";
import { Group } from "../../../../../model/GroupModel";
import { UserGroupsVO, UserLazy } from "../../../../../model/UserModel";
import { DeleteGroup, GetOneGroup, GetUsersGroup } from "../../../../../services/GroupsServices";
import { RemoveUserGroup } from "../../../../../services/UserServices";
import { DisableUserAndGroupModal } from "../DisableUserAndGroupModal/DisableUserAndGroupModal";
import UsersTable from "../UsersTable/UsersTable";

export const GroupPage = () => {

    const {t} = useTranslation();
    const {nameOrg, idGroup} = useParams();
    const navigate = useNavigate();

    const [group, setGroup] = useState<Group | undefined>()
    const [search, setSearch] = useState<string>('')
    const [users, setUsers] = useState<UserLazy[]>([])
    const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
    const [messageSnack, setMessageSnack] = useState<string>('');
    const [colorSnack, setColorSnack] = useState<AlertColor | undefined>();
    const [loading, setLoading] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [isModalDisableOpen, setIsModalDisableOpen] = useState<boolean>(false);
    const open = Boolean(anchorEl);

    const handleBackClick = () => {
        navigate(`/${nameOrg}/adminConsole/usersAndGroups`);
    };

    const onChangeSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value != undefined) {
            setSearch(event.target.value);
        }
    }

    const handleSnackbarWithMessage = (message: string, color: AlertColor) => {
        setOpenSnackbar(true);
        setMessageSnack(message)
        setColorSnack(color)
    }

    const handleRemoveUser = (userId: string) => {
        const userGroup: UserGroupsVO = {
            userId: userId,
            groupId: group!.id
        };

        setLoading(true);

        RemoveUserGroup(userGroup)
            .then((data) => {
                handleSnackbarWithMessage(t("AdminConsole.UserRemovedFromGroup"), 'success');
                setUsers((prevUsers) => prevUsers.filter(user => user.id !== userId));
            })
            .catch((err) => {
                handleSnackbarWithMessage(err.response.data, 'error');
            })
            .finally(() => setLoading(false));
    };

    const handleConfirmDelete = () => {
        DeleteGroup(group?.id!)
            .then((data) => {
                handleSnackbarWithMessage(t("GrupoExcluido.message"), 'success')
                navigate(`/${nameOrg}/adminConsole/usersAndGroups`)
            })
            .catch((err) => handleSnackbarWithMessage(err.response.data, 'error'));
        handleDialog();
    };

    const handleDialog = () => {
        setIsModalDisableOpen(!isModalDisableOpen);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault(); 
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (idGroup) {
            setLoading(true);
            GetOneGroup(idGroup)
                .then((data) => setGroup(data))
                .catch((err) => console.log(err));

            GetUsersGroup(idGroup, 0, 50)
                .then((data) => {
                    setUsers(data);
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => setLoading(false))
        }

    }, [idGroup]);

    const styles = {
        container: {
            background: '#F7F8FA',
            padding: '30px',
        },
        panel: {
            background: '#FFFFFF',
            border: '1px solid #0000001A',
            borderRadius: '4px',
            height: '100%',
            padding: '30px',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
        },
        iconButton: {
            borderRadius: '4px',
            font: 'normal normal normal 14px / 21px Segoe UI',
            color: "#22638D",
            '&:hover': {
                backgroundColor: "#F4F7F9",
            },
        },
        headerText: {
            display: 'flex',
            alignItems: 'center',
            font: 'normal normal 600 20px/ 27px Segoe UI',
        },
        sectionTitle: {
            font: 'normal normal 600 16px/ 24px Segoe UI',
        },
        searchInput: {
            height: '36px',
            padding: '0 10px',
            '& .MuiFilledInput-input': {
                height: '36px',
                padding: '0 10px',
                display: 'flex',
                alignItems: 'center',
            },
            '& .MuiInputBase-root': {
                height: '36px',
                backgroundColor: '#f0f0f0',
                borderRadius: '4px',
            },
            '& input::placeholder': {
                fontSize: '14px',
                color: '#969696',
            },
        },
    };

    
    return (
        <>
            <Box sx={styles.container}>
                <Box sx={styles.panel}>
                    <Box>
                        <IconButton sx={styles.iconButton} onClick={handleBackClick}>
                            <ArrowBackIosIcon sx={{ height: '12px' }} />
                            <Typography>{t("AdminConsole.Back")}</Typography>
                        </IconButton>
                    </Box>

                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography sx={styles.headerText}>
                            <GroupIcon sx={{ width: '24px', height: '24px', marginRight: '12px', color: '#22638D' }} />
                            {group?.name}
                        </Typography>

                        <Box sx={{display:"flex"}}>
                            <TextField
                                fullWidth
                                id="filled-basic"
                                variant="filled"
                                placeholder={t('AdminConsole.WhatAreYouLookingFor')}
                                onChange={onChangeSearch}
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: (
                                        <Box sx={{ display: 'flex', alignItems: 'center', paddingRight: '10px', opacity: '0.5' }}>
                                            <Search />
                                        </Box>
                                    ),
                                    sx: styles.searchInput,
                                }}
                            />

                            <IconButton
                                aria-label="more"
                                id="long-button"
                                aria-controls={open ? 'long-menu' : undefined}
                                aria-expanded={open ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={handleClick}
                            >
                                <MoreVertIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={handleDialog}>
                                    <DeleteIcon />
                                    {t("AdminConsole.DisableGroup")}
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Box>

                    <Divider />

                    <Typography sx={styles.sectionTitle}>{t("AdminConsole.Owner")}</Typography>
                    <Box flex={1}>
                        {loading ?
                            <LoaderComp />
                            :
                            <UsersTable nameOrg={nameOrg!} search={search} isGroupPage={true} usersIdList={group?.owner !== undefined ? [group.owner] : []} removeFromGroup={handleRemoveUser} hasPhoneColumn={true} />
                        }
                    </Box>

                    <Divider />

                    <Typography sx={styles.sectionTitle}>{t("AdminConsole.Participants")}</Typography>
                    <Box flex={1}>
                        {loading ?
                            <LoaderComp/>
                        :
                            <UsersTable nameOrg={nameOrg!} search={search} isGroupPage={true} usersIdList={users !== undefined ? users.map((u)=> u.id!) : []} removeFromGroup={handleRemoveUser} hasPhoneColumn={true} />
                        }
                    </Box>

                    <Snackbar
                        open={openSnackbar}
                        autoHideDuration={6000}
                        onClose={() => setOpenSnackbar(false)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    >
                        <Alert
                            onClose={() => setOpenSnackbar(false)}
                            severity={colorSnack}
                            variant="filled"
                            sx={{ width: '100%' }}
                        >
                            {messageSnack}
                        </Alert>
                    </Snackbar>
                </Box>
            </Box>
            <DisableUserAndGroupModal isopen={isModalDisableOpen} handleClickConfirm={handleConfirmDelete} handleOpenDialog={handleDialog} isUser={false} groupName={group?.name} />
        </>
    )
}